module.exports = __webpack_public_path__ + "img/Vaishvi Soni tran.08b0ba3f.png";